
import { Row, Card, Col, Form } from "react-bootstrap";
import { http } from "Utils/http";
import { useEffect,  useState } from "react";
import Stack from 'react-bootstrap/Stack';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-phone-input-2/lib/style.css'
import { TextButton } from 'Components/Button';
import { ERROR_MESSAGES} from "Utils/constants";
import { useDispatch } from "react-redux"
import { setGlobalSuccessStatus, setGlobalErrorStatus } from 'Components/StatusHandling';
import 'react-phone-input-2';
import { store } from 'Store';
import { GetDocumentTextInputData, GetDocumentRadioInputData, GetDocumentNumberInputData, GetDocumentCheckboxInputData, GetDocumentSelectInputData, GetDocumentDateInputData, GetDocumentTextAreaInputData, GetDocumentFileInputData, GetDocumentPlainTextInputData } from 'Containers/Private/DLMS/DocumentBeanFields';
import { FormInputDisplay } from 'Components/Forms/FormInputDisplay.js';

const emptyFile = new File([], null);
const hForm = { is: true, labelCols: { lg: 3, md: 4 }, inputCols: { lg: 5 } };

function CreateDocument () {
    const getDateFormat = (value) => {
        if (value != null) {
            var split = value.split('-');
            //console.log(split);
            if (split.length == 3) {
                return split[1] + '/' + split[2] + '/' + split[0];
            }
            return value;
        }
        return "";
    }
    const formatReturnDate = (value) => {
        if (value != null) {
            var split = value.split('/');
            //console.log(split);
            if (split.length == 3) {
                return split[2] + '-' + split[0] + '-' + split[1];
            }
            return value;
        }
        return "";
    }
    const ACTIONS = {
        CALL_API: 'call-api',
        SUCCESS: 'success',
        ERROR: 'error',
        SET_INITIAL_DATA: 'set-data',

        TEXT_CHANGE: 'text-change',
        TEXT_SET_ERRORS: 'text-set-errors',
        TEXT_REMOVE_ERRORS: 'text-remove-errors',
        TEXT_AREA_CHANGE: 'text-area-change',

        RADIO_CHANGE: 'radio-change',
        RADIO_SET_ERRORS: 'radio-set-errors',
        RADIO_REMOVE_ERRORS: 'radio-remove-errors',

        SELECT_CHANGE: 'select-change',
        SELECT_SET_ERRORS: 'select-set-errors',
        SELECT_REMOVE_ERRORS: 'select-remove-errors',
        SELECT_UPDATE_CHOICES: 'select-update-choices',

        SET_INITIAL_CHECK_DATA: 'set-check-data',
        CHECK_UPDATE_CHOICES: 'check-update-choices',
        CHECK_CHANGE: 'check-change',
        CHECK_TOGGLE_DISABLE: 'check-toggle-disable',
        //CHECK_REQUIRED_CHANGE: 'check-required-change',
        CHECK_SET_ERRORS: 'check-set-errors',
        CHECK_REMOVE_ERRORS: 'check-remove-errors',

        DATE_CHANGE: 'date-change',
        DATE_SET_ERRORS: 'date-set-errors',
        DATE_REMOVE_ERRORS: 'date-remove-errors',

        PHONE_CHANGE: 'phone-change',
        PHONE_SET_ERRORS: 'phone-set-errors',
        PHONE_REMOVE_ERRORS: 'phone-remove-errors',

        FILE_CHANGE: 'file-change',
        FILE_SET_ERRORS: 'file-set-errors',
    };

    let location = useLocation();

    const navigate = useNavigate();
    var passedData = location.state;


    //console.log(passedData);
    const dispatch = useDispatch();

    const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);
    const [groupId] = useState(passedData.groupId ? passedData.groupId : 0);
    const [docId] = useState(passedData.docId ? passedData.docId : 0);
    const [isLoading, setIsLoading] = useState(true);

    const [pageType, setPageType] = useState(null);
 
    var [docDocumentId, docDocumentIdInputDispatch] = GetDocumentPlainTextInputData('docId', docId, 'create'); //0
    var [docGroupId, docGroupIdInputDispatch] = GetDocumentPlainTextInputData('groupId', groupId, 'create'); //0
    var [docName, docNameInputDispatch] = GetDocumentPlainTextInputData('docName', "", 'create'); //0

    var [docUploadFile, docUploadFileInputDispatch] = GetDocumentFileInputData('uploadFile', [], "", 'create');
    var [docOwnerId, docOwnerIdInputDispatch] = GetDocumentSelectInputData('ownerId', 0, 'create'); //0
    var [docCategoryId, docCategoryIdInputDispatch] = GetDocumentSelectInputData('categoryId', 0, 'create'); //0
    var [docVersion, docVersionInputDispatch] = GetDocumentNumberInputData('version', '', 'create');
    var [docDisplayName, docDisplayNameInputDispatch] = GetDocumentTextInputData('displayName', '', 'create');
    var [docShortName, docShortNameInputDispatch] = GetDocumentTextInputData('shortName', '', 'create');

    var [docDisplayOrder, docDisplayOrderInputDispatch] = GetDocumentNumberInputData("displayOrder", '', 'create');

    var [docDescription, docDescriptionInputDispatch] = GetDocumentTextAreaInputData('docDescr', '', 'create');

    var [docPubDate, docPubDateInputDispatch] = GetDocumentDateInputData('docPubDate', '', 'create');
    var [docAllowPubAccess, docAllowPubAccessInputDispatch] = GetDocumentRadioInputData('allowPubAccess', '', 'create');
    var [docRoleIds, docRoleIdsInputDispatch] = GetDocumentCheckboxInputData('roleIds', '', 'create');
    var [docIsDisabled, docIsDisabledInputDispatch] = GetDocumentRadioInputData('isDisabled', '', 'create');
    var [docIsOpenForComment, docIsOpenForCommentInputDispatch] = GetDocumentRadioInputData('isOpenForComment', '', 'create');


    useEffect(()=>{
        if(docAllowPubAccess!=null){
            if(docAllowPubAccess.getValue(docAllowPubAccess.radioButtons)=="Y" && docRoleIds.isDisabled!=true){
                docRoleIdsInputDispatch({
                    type: ACTIONS.CHECK_TOGGLE_DISABLE,
                    disabled: true
                })
            }
            else{
                if(docRoleIds.isDisabled!=false){
                    docRoleIdsInputDispatch({
                        type: ACTIONS.CHECK_TOGGLE_DISABLE,
                        disabled: false
                    })
                }
                
            }
        }
    },[docAllowPubAccess])

    const getFormData = async () => {

        var url = '/api/dlms/newDocument';
        const loginState = store.getState().loginInfo;

        return http.post(url, null, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        });
    }

    const getNewVerFormData = async (isNew) => {
        setIsLoading(true);
        var url = null;
        var values = null;

        if(isNew!=true){
            url = '/api/dlms/editDocument';
            values = {
                groupId: passedData.groupId,
                docId: passedData.docId
            }
        }
        else{
            url = '/api/dlms/newDocumentVersion';
            values = {
                groupId: passedData.groupId
            }
        }
        const loginState = store.getState().loginInfo;

        return http.post(url, values, {
            headers: {
                "Authorization": "Bearer " + loginState.token
            }
        });
    }

    const loadFormData = () => {
        setIsLoading(true);
        getFormData().then((res) => {
            //console.log("getFormData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;

                if (d.allRoles != null) {
                    var o = d.allRoles.map((option) => {
                        var role = {
                            id: option.roleName,
                            label: option.description,
                            title: null,
                            name: option.roleName,
                            value: option.roleId,
                            isChecked: false,
                            disabled: option.isEnabled == 1 ? false : true
                        }
                        //console.log(role);
                        return role;
                    });
                    docRoleIdsInputDispatch({
                        type: ACTIONS.CHECK_UPDATE_CHOICES,
                        options: o
                    })
                }
                if (d.ownerList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: null,
                        title: null,
                        displayValue: "Select Document Owner",
                        isSelected: true
                    })
                    d.ownerList.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.ownerName,
                            value: option.ownerId,
                            title: null,
                            displayValue: option.ownerName,
                            isSelected: false,
                            name: option.ownerName,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    docOwnerIdInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                }
                if (d.catList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: null,
                        title: null,
                        displayValue: "Select Document Category",
                        isSelected: true
                    })
                    d.catList.map((option, index) => {
                        //console.log(option);
                        var category = {
                            index: index,
                            id: option.categoryName,
                            value: option.categoryId,
                            title: null,
                            displayValue: option.categoryName,
                            isSelected: false,
                            name: option.categoryName,
                            disabled: false
                        }
                        o.push(category);
                        //console.log(category);
                        return category;
                    });

                    docCategoryIdInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                }

                docVersionInputDispatch({
                    type: ACTIONS.TEXT_CHANGE,
                    value: 1
                })

                return d;
            }
        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        setIsLoading(false);
    };

    const loadNewVersionFormData = (isNew) => {
        setIsLoading(true);
        getNewVerFormData(isNew).then((res) => {
            //console.log("getFormData ", res);
            if (res.status != 1) {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.DATA_ERROR.title,
                        msg: res.globalErrorMessageList[0],
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
            else {
                var d = res.data;
                //console.log(d);
                //console.log(d.documentDetailBean.roles);
                //console.log(d);

                if (d.allRoles != null) {
                    var o = d.allRoles.map((option) => {
                        var role = {
                            id: option.roleName,
                            label: option.description,
                            title: null,
                            name: option.roleName,
                            value: option.roleId,
                            isChecked: d.documentDetailBean.roles.includes(option.roleId + "") ? true : false,
                            //onChange: handleCheckChange,
                            disabled: option.isEnabled == 1 ? false : true
                        }
                        //console.log(option.roleId);
                        //console.log(d.documentDetailBean.roles);
                        //console.log(d.documentDetailBean.roles.includes(option.roleId+""));
                        //console.log(role);
                        return role;
                    });
                    //console.log(o);
                    docRoleIdsInputDispatch({
                        type: ACTIONS.CHECK_UPDATE_CHOICES,
                        options: o
                    })
                }
                if (d.ownerList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: null,
                        title: null,
                        displayValue: "Select Document Owner",
                        isSelected: d.documentDetailBean.ownerId==null ? true : false,
                    })
                    d.ownerList.map((option, index) => {
                        //console.log(option);
                        var owner = {
                            index: index,
                            id: option.ownerName,
                            value: option.ownerId,
                            title: null,
                            displayValue: option.ownerName,
                            isSelected: d.documentDetailBean.ownerId == option.ownerId ? true : false,
                            name: option.ownerName,
                            disabled: false
                        }
                        o.push(owner);
                        //console.log(owner);
                        return owner;
                    });

                    docOwnerIdInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                }
                if (d.catList != null) {
                    var o = [];
                    o.push({
                        index: null,
                        value: null,
                        title: null,
                        displayValue: "Select Document Category",
                        isSelected: d.documentDetailBean.categoryId==null ? true : false,
                    })
                    d.catList.map((option, index) => {
                        //console.log(option);
                        var category = {
                            index: index,
                            id: option.categoryName,
                            value: option.categoryId,
                            title: null,
                            displayValue: option.categoryName,
                            isSelected: d.documentDetailBean.categoryId == option.categoryId ? true : false,
                            name: option.categoryName,
                            disabled: false
                        }
                        o.push(category);
                        //console.log(category);
                        return category;
                    });

                    docCategoryIdInputDispatch({
                        type: ACTIONS.SELECT_UPDATE_CHOICES,
                        options: o
                    })
                }

                var bean = d.documentDetailBean;
                if (bean != null) {
                    if(bean.displayName!=null){
                        docDisplayNameInputDispatch({
                            type: ACTIONS.TEXT_CHANGE,
                            value: bean.displayName
                        })
                    }
                    if(bean.shortName!=null){
                        docShortNameInputDispatch({
                            type: ACTIONS.TEXT_CHANGE,
                            value: bean.shortName
                        })
                    }
                    if(bean.version!=null){
                        docVersionInputDispatch({
                            type: ACTIONS.TEXT_CHANGE,
                            value: isNew==true ? (bean.version + 1) : bean.version
                        })
                    }
                    if(bean.displayOrder!=null){
                        docDisplayOrderInputDispatch({
                            type: ACTIONS.TEXT_CHANGE,
                            value: bean.displayOrder
                        })
                    }
                    if(bean.docDescr!=null){
                        docDescriptionInputDispatch({
                            type: ACTIONS.TEXT_AREA_CHANGE,
                            value: bean.docDescr
                        })
                    }
                    if(bean.docPubDate!=null){
                        docPubDateInputDispatch({
                            type: ACTIONS.DATE_CHANGE,
                            value: formatReturnDate(bean.docPubDate)
                        })
                    }

                    if(bean.allowPubAccess!=null){
                        var v = bean.allowPubAccess;
                        if(v=="Yes"){
                            v="Y";
                        }
                        if(v=="No"){
                            v="N";
                        }
                        docAllowPubAccessInputDispatch({
                            type: ACTIONS.RADIO_CHANGE,
                            value: v
                        })
                    }
                    if(bean.isOpenForComment!=null){
                        docIsOpenForCommentInputDispatch({
                            type: ACTIONS.RADIO_CHANGE,
                            value: bean.isOpenForComment
                        })
                    }

                    if(isNew==false){
   
                        if(bean.isDisabled!=null){
                            var v = bean.isDisabled;

                            if(v=="Yes"){
                                v="Y";
                            }
                            if(v=="No"){
                                v="N";
                            }
                            
                            docIsDisabledInputDispatch({
                                type: ACTIONS.RADIO_CHANGE,
                                value: v
                            })
                        }

                        
                        if(bean.docName!=null){
                            docNameInputDispatch({
                                type: ACTIONS.TEXT_CHANGE,
                                value: bean.docName
                            })
                        }
                    }
                }

                return d;
            }

        }).catch((error) => {
            //console.log("Error caught while loading data: " + error);

            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.DATA_ERROR.title,
                    msg: ERROR_MESSAGES.DATA_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        setIsLoading(false);
    };

    useEffect(() => {
        
        if(docId>0 && groupId>0){
            setPageType("EDIT");
            loadNewVersionFormData(false);
        }
        else if(groupId>0){
            setPageType("CREATE-VER");
            loadNewVersionFormData(true);
        }
        else{
            setPageType("CREATE");
            loadFormData();
        }

    }, [])


    useEffect(() => {
        //console.log(docUploadFile.files);
    }, [docUploadFile])


    const handleCancel = async () => {
        if (backRedirect.path == null) {
            setBackRedirect("/manage/document");
        }
        //localStorage.setItem('state', JSON.stringify(backRedirect.state));
        navigate(
            backRedirect.path,
            { state: backRedirect.state }
        );
    };

    const getUploadData = (files) => {
        var formData = new FormData();
        
        if(pageType!="EDIT"){
            //console.log(files[0]);
            formData.append('file', files.length > 0 ? files[0] : emptyFile);
        }
        
        var data = {
            docId: docId,
            //groupId: null,
            categoryId: docCategoryId.getValue(docCategoryId.options),
            ownerId: docOwnerId.getValue(docOwnerId.options),

            //uploadFile:  ,
            displayName: docDisplayName.value,
            //shortName: docShortName.value,
            docDescr: docDescription.value,
            
            roleIds: docRoleIds.getValue(docRoleIds.checkBoxes),
            docPubDate: getDateFormat(docPubDate.value),

        };
        if (!isNaN(docVersion.value) && (docVersion.value != null && docVersion.value != "")) {
            data['version'] = docVersion.value;
        }
        if (!isNaN(docDisplayOrder.value) && (docDisplayOrder.value != null && docDisplayOrder.value != "")) {
            data['displayOrder'] = docDisplayOrder.value;
        }

        if (groupId!=null && groupId>0) {
            data['groupId'] = groupId;
        }
       
        if (docShortName.value!=null && docShortName.value != "") {
            data['shortName'] = docShortName.value;
        }

        var allow = docAllowPubAccess.getValue(docAllowPubAccess.radioButtons);
        if (allow != "") {
            data['allowPubAccess'] = allow;
        }
        var disabled = docIsDisabled.getValue(docIsDisabled.radioButtons);
        if (disabled != "") {
            data['isDisabled'] = disabled;
        }
        var open = docIsOpenForComment.getValue(docIsOpenForComment.radioButtons);
        if (open != "") {
            data['isOpenForComment'] = open;
        }

        if(pageType!="EDIT"){
            formData.append("uploadData", JSON.stringify(
                data
            ))
            //console.log(...formData);
            return formData;
        }
        else{
            formData.append("updateDocumentBean", JSON.stringify(
                data
            ))
            //console.log(...formData);
            return formData;            
        }
    }

    const fieldDataAccess = {
        uploadFile: {
            value: docUploadFile,
            dispatch: docUploadFileInputDispatch
        },
        ownerId: {
            value: docOwnerId,
            dispatch: docOwnerIdInputDispatch
        },
        categoryId: {
            value: docCategoryId,
            dispatch: docCategoryIdInputDispatch
        },
        version: {
            value: docVersion,
            dispatch: docVersionInputDispatch
        },
        displayOrder: {
            value: docDisplayOrder,
            dispatch: docDisplayOrderInputDispatch
        },
        displayName: {
            value: docDisplayName,
            dispatch: docDisplayNameInputDispatch
        },
        shortName: {
            value: docShortName,
            dispatch: docShortNameInputDispatch
        },
        docDescr: {
            value: docDescription,
            dispatch: docDescriptionInputDispatch
        },
        docPubDate: {
            value: docPubDate,
            dispatch: docPubDateInputDispatch
        },
        allowPubAccess: {
            value: docAllowPubAccess,
            dispatch: docAllowPubAccessInputDispatch
        },
        roleIds: {
            value: docRoleIds,
            dispatch: docRoleIdsInputDispatch
        },
        isDisabled: {
            value: docIsDisabled,
            dispatch: docIsDisabledInputDispatch
        },
        isOpenForComment: {
            value: docIsOpenForComment,
            dispatch: docIsOpenForCommentInputDispatch
        },
    }

    function addErrorMessages (object, fieldErrors, dispatch, isFirst) {
        //console.log("ADD ERROR MESSAGES", object, fieldErrors);

        if (fieldErrors != null) {

            var err = fieldErrors.errorMessages;


            if (isFirst == true) {
                (object.InputRef).current.focus();
                //console.log("ISFIRST");
            }

            var type = object.type;

            switch (type) {
                case "text":
                    dispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: err
                    })
                    break;
                case "file":
                    dispatch({
                        type: ACTIONS.FILE_SET_ERRORS,
                        errors: err
                    })
                    break;
                case "textarea":
                    dispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: err
                    })
                    break;
                case "number":
                    dispatch({
                        type: ACTIONS.TEXT_SET_ERRORS,
                        errors: err
                    })
                    break;
                case "date":
                    dispatch({
                        type: ACTIONS.DATE_SET_ERRORS,
                        //name: fieldName,
                        errors: err
                    })
                    break;
                case "select":
                    dispatch({
                        type: ACTIONS.SELECT_SET_ERRORS,
                        //name: fieldName,
                        errors: err
                    })
                    break;
                case "radio":
                    dispatch({
                        type: ACTIONS.RADIO_SET_ERRORS,
                        //name: fieldName,
                        errors: err
                    })
                    break;
                case "checkbox":
                    dispatch({
                        type: ACTIONS.CHECK_SET_ERRORS,
                        //name: fieldName,
                        errors: err
                    })
                    break;
                case "tel":
                    dispatch({
                        type: ACTIONS.PHONE_SET_ERRORS,
                        //name: fieldName,
                        errors: err
                    })
                    break;
            }

        }
    }
    
    const handleSubmit = async () => {
        var percentCompleted = 0;
        var url = null;
        if(pageType!="EDIT"){
            url = '/api/dlms/addDocument';
        }
        else{
            url = '/api/dlms/updateDocument';
        }

        var values = getUploadData(docUploadFile.files);
        const loginState = store.getState().loginInfo;
        const res = http.post(url, values, {
            onUploadProgress: function(progressEvent) {
                percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
                //console.log(percentCompleted);
            },
            headers: {
                "Authorization": "Bearer " + loginState.token,
                "Content-Type": "multipart/form-data"
            }
        }).then((response) => {
            //console.log("print out /users/adduser", response);
            if (response != null) {
                //console.log(response);
                var statusCode = response.status;
                if (statusCode != 1) {

                    if (response.globalErrorMessageList && response.globalErrorMessageList.length > 0) {
                        setGlobalErrorStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: ERROR_MESSAGES.GENERAL_ERROR.title,
                                msg: response.globalErrorMessageList,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: false,
                                redirectFirst: false,
                                path: "",
                                data: {}
                            }
                        });
                    }

                    var d = response.fieldErrors;
                    //console.log("field errors", d);

                    var x = 0;
                    var isFirst = false;

                    for (const [key, value] of Object.entries(fieldDataAccess)) {
                        //console.log("Key: ", key);
                        //console.log("Value: ", value);

                        var values = d[key];
                        //console.log("VALUES", values);

                        if (values != null) {
                            var disp = value.dispatch;
                            var obj = value.value;

                            if (x == 0) {
                                isFirst = true;
                            }
                            else {
                                isFirst = false;
                            }
                            addErrorMessages(obj, values, disp, isFirst);
                            x = x + 1;
                        }
                    }
                }
                else {
                    if (backRedirect.path == null) {
                        setBackRedirect("/manage/document");
                    }

                    if(pageType!="EDIT"){
                        //console.log(percentCompleted);
                        setGlobalSuccessStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: "Success!",
                                msg: "Document has been sucessfully created.",
                                //msg: response.message,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: true,
                                redirectFirst: true,
                                path: backRedirect.path,
                                data: { state: backRedirect.state }
                            }
                        });
                    }
                    else{
                        setGlobalSuccessStatus({
                            dispatch: dispatch,
                            popupData: {
                                visible: true,
                                title: "Success!",
                                msg: "Document has been sucessfully updated.",
                                //msg: response.message,
                                showContactHelp: false
                            },
                            redirect: {
                                redirect: true,
                                redirectFirst: true,
                                path: backRedirect.path,
                                data: { state: backRedirect.state }
                            }
                        });
                    }
                }

            }
            else {
                setGlobalErrorStatus({
                    dispatch: dispatch,
                    popupData: {
                        visible: true,
                        title: ERROR_MESSAGES.GENERAL_ERROR.title,
                        msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                        showContactHelp: true
                    },
                    redirect: {
                        redirect: false,
                        redirectFirst: false,
                        path: "",
                        data: {}
                    }
                });
            }
        }).catch(function (error) {
            //console.log("submitUser", error);
            setGlobalErrorStatus({
                dispatch: dispatch,
                popupData: {
                    visible: true,
                    title: ERROR_MESSAGES.GENERAL_ERROR.title,
                    msg: ERROR_MESSAGES.GENERAL_ERROR.message,
                    showContactHelp: true
                },
                redirect: {
                    redirect: false,
                    redirectFirst: false,
                    path: "",
                    data: {}
                },
                error: error
            });
        });
        //console.log("submitUser", res);
        return res;
    };

    return (
        <Row >
            {
                isLoading ? 
                    null
                :  
                <Row >
                    <Col xl={11} lg={11} md={11} sm={12}>
                        <Card className="p-4" >
                            <Card.Body className="text-start">
                                    {
                                        pageType=="CREATE" 
                                        ?   <Row>
                                                <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Add New Document</h1>                                    
                                                <p>To upload a new document, enter the required information below. The new document should be in one of the following file extentions: .doc, .docx, .pdf, .ppt, .xls, .xlsx, and .zip.</p>
                                            </Row>
                                        :
                                            pageType=="CREATE-VER" 
                                            ?
                                                <Row>
                                                    <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Add New Version For Document</h1>
                                                    <p>To upload a new document, enter the required information below. The new document should be in one of the following file extentions: .doc, .docx, .pdf, .ppt, .xls, .xlsx, and .zip. </p>
                                                </Row>
                                                
                                            :
                                                pageType=="EDIT" 
                                                ?
                                                    <Row>
                                                        <h1 id="mainContent" className="header1 text-start mb-3 blue bold">Edit Document</h1>
                                                        <p>To edit the document, enter the required information below. </p>
                                                    </Row>
                                                    
                                                :
                                                    null

                                    }
                               
                                <Row>
                                    {/*<Button onClick={enterData}>Test</Button>*/}
                                    <Form>

                                        {
                                            pageType!="EDIT" 
                                            ?                                        
                                                <FormInputDisplay fieldData={docUploadFile} inputDispatch={docUploadFileInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                            :
                                                <>
                                                    <FormInputDisplay fieldData={docDocumentId} inputDispatch={docDocumentIdInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={docGroupId} inputDispatch={docGroupIdInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                                    <FormInputDisplay fieldData={docName} inputDispatch={docNameInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                                
                                                </>
                                        }
                                        
                                        <FormInputDisplay fieldData={docCategoryId} inputDispatch={docCategoryIdInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>  
                                        <FormInputDisplay fieldData={docOwnerId} inputDispatch={docOwnerIdInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        
                                        <FormInputDisplay fieldData={docDisplayName} inputDispatch={docDisplayNameInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docShortName} inputDispatch={docShortNameInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docVersion} inputDispatch={docVersionInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docDisplayOrder} inputDispatch={docDisplayOrderInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docDescription} inputDispatch={docDescriptionInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docPubDate} inputDispatch={docPubDateInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docAllowPubAccess} inputDispatch={docAllowPubAccessInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docRoleIds} inputDispatch={docRoleIdsInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docIsDisabled} inputDispatch={docIsDisabledInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>
                                        <FormInputDisplay fieldData={docIsOpenForComment} inputDispatch={docIsOpenForCommentInputDispatch} isHorizontal={false} hideLabel={false} horizontalForm={hForm}></FormInputDisplay>

                                        <Stack className="pt-3" direction="horizontal" gap={3}>
                                            {/* Submit Button */}
                                            <TextButton
                                                variant="normal"
                                                onClick={handleSubmit}
                                                content={"Submit"}
                                            >
                                            </TextButton>

                                            {/* Cancel Button */}
                                            <TextButton
                                                variant="outline"
                                                onClick={handleCancel}
                                                content={"Cancel"}
                                            >
                                            </TextButton>
                                        </Stack>

                                    </Form>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            }

        </Row>
    );
}

export default CreateDocument;